// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"943":"247c46a0","2411":"8324eade","7720":"6cd173eb","9275":"c0a212da"}[chunkId] + ".chunk.css";
};